import {
  createCustomObject,
  updateCustomObject,
  fetchCustomObjects,
  showCustomObjectAddEditForm,
  createCustomObjectInstance,
  updateCustomObjectInstance,
  archiveCustomObjectInstance,
  fetchCustomObjectInstances,
  archiveCustomObject,
  fetchCustomObjectById,
  fetchCustomObjectsLimit,
} from '../routines/customObjectRoutines';

const initialState = {
  customObjectData: [],
  customObjectLimit: null,
  isCustomObjectLoading: false,
  customObjectError: null,
  customObjectInstanceError: null,
  selectedCustomObject: null,
  selectedCustomObjectInstance: null,
  isCustomObjectInstanceLoading: false,
  showAddEditForm: false,
  addEditFormCustomObjectId: null,
  customObjectInstanceData: {},
  listPageData: {},
  currentPayload: {},
  createEditCustomObject: {
    loading: false,
    error: null,
  },
  createEditCustomObjectInstance: {
    loading: false,
    error: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case fetchCustomObjects.TRIGGER:
      return {
        ...state,
        isCustomObjectLoading: true,
        customObjectError: null,
      };
    case createCustomObject.TRIGGER:
    case updateCustomObject.TRIGGER:
      return {
        ...state,
        createEditCustomObject: {
          ...state.createEditCustomObject,
          loading: true,
          error: null,
        },
      };

    case archiveCustomObject.TRIGGER: {
      return {
        ...state,
        isCustomObjectLoading: false,
      };
    }

    case archiveCustomObjectInstance.TRIGGER: {
      return {
        ...state,
        isCustomObjectInstanceLoading: false,
      };
    }

    case fetchCustomObjectInstances.TRIGGER:
      return {
        ...state,
        isCustomObjectInstanceLoading: true,
        customObjectInstanceError: null,
      };

    case createCustomObjectInstance.TRIGGER:
    case updateCustomObjectInstance.TRIGGER:
      return {
        ...state,
        createEditCustomObjectInstance: {
          ...state.createEditCustomObjectInstance,
          loading: true,
          error: null,
        },
      };
    case showCustomObjectAddEditForm.TRIGGER:
      return {
        ...state,
        showAddEditForm: action.payload.showForm,
        addEditFormCustomObjectId: action.payload.customObjectId,
      };

    case fetchCustomObjects.SUCCESS: {
      return {
        ...state,
        isCustomObjectLoading: false,
        customObjectError: null,
        customObjectData: action.payload,
      };
    }

    case fetchCustomObjectsLimit.SUCCESS: {
      return {
        ...state,
        customObjectLimit: action.payload,
      };
    }
    case fetchCustomObjectInstances.SUCCESS: {
      const { level, data } = action.payload;
      const customObjectInstanceData = {
        ...state.customObjectInstanceData,
        [level]: data,
      };
      const listPageData = {
        ...state.listPageData,
        [level]: {
          itemCount: action.payload.itemCount,
          page: action.payload.page,
          pageSize: action.payload.pageSize,
          totalItems: action.payload.totalItemCount,
          totalEntities: action.payload.totalEntityCount,
          lifecycleGroupTotalItemCounts:
            action.payload.lifecycleGroupTotalItemCounts || 0,
        },
      };
      const currentPayload = {
        ...state.currentPayload,
        [level]: action.payload.currentPayload,
      };
      return {
        ...state,
        isCustomObjectInstanceLoading: false,
        customObjectInstanceError: null,
        customObjectInstanceData,
        listPageData,
        currentPayload,
      };
    }

    case createCustomObject.SUCCESS: {
      return {
        ...state,
        createEditCustomObject: {
          ...state.createEditCustomObject,
          loading: false,
          error: null,
        },
      };
    }
    case updateCustomObject.SUCCESS: {
      return {
        ...state,
        selectedCustomObject: action.payload.response.data,
        createEditCustomObject: {
          ...state.createEditCustomObject,
          loading: false,
          error: null,
        },
      };
    }

    case createCustomObjectInstance.SUCCESS:
    case updateCustomObjectInstance.SUCCESS: {
      return {
        ...state,
        createEditCustomObjectInstance: {
          ...state.createEditCustomObjectInstance,
          loading: false,
          error: null,
        },
      };
    }

    case fetchCustomObjectById.SUCCESS: {
      return {
        ...state,
        isCustomObjectLoading: false,
        selectedCustomObject: action.payload,
      };
    }
    case archiveCustomObject.SUCCESS: {
      return {
        ...state,
        isCustomObjectLoading: false,
        selectedCustomObject: null,
      };
    }

    case archiveCustomObjectInstance.SUCCESS: {
      return {
        ...state,
        isCustomObjectInstanceLoading: false,
        selectedCustomObjectInstance: null,
      };
    }

    case fetchCustomObjectById.FAILURE:
    case fetchCustomObjects.FAILURE: {
      return {
        ...state,
        isCustomObjectLoading: false,
        customObjectError: action.payload.error,
      };
    }

    case fetchCustomObjectInstances.FAILURE: {
      return {
        ...state,
        isCustomObjectInstanceLoading: false,
        customObjectInstanceError: action.payload.error,
      };
    }

    case createCustomObject.FAILURE:
    case updateCustomObject.FAILURE: {
      return {
        ...state,
        createEditCustomObject: {
          ...state.createEditCustomObject,
          loading: false,
          error: action.payload.error,
        },
      };
    }

    case createCustomObjectInstance.FAILURE:
    case updateCustomObjectInstance.FAILURE: {
      return {
        ...state,
        createEditCustomObjectInstance: {
          ...state.createEditCustomObjectInstance,
          loading: false,
          error: action.payload.error,
        },
      };
    }

    default:
      return state;
  }
};
